<template>
  <div class="_content">
    <div class="content">
      <div class="item-box1">
        <div>太平券码</div>
        <div>{{ codeInfo.orderId }}</div>
      </div>
      <div class="item-box1">
        <div>券码状态</div>
        <div>{{ codeInfo.orderType == 1 ? '预约' : '非预约' }}-{{ statusType[codeInfo.status] }}</div>
      </div>
      <div class="item-box1">
        <div>车牌号码</div>
        <div>{{ codeInfo.carNumber }}</div>
      </div>
      <div class="item-box1">
        <div>服务名称</div>
        <div style="text-align:right">{{ codeInfo.companyCode }}<br />{{ codeInfo.serviceDetailName }}</div>
      </div>
      <div class="item-box2">
        <div class="box">
          <p>上传服务照片</p>
          <p @click="showPupup = true" class="img">
            查看范例
            <img class="icon" src="~@/imgs/arrow-right-grey2.png" alt="" />
          </p>
        </div>
        <!-- 上传图片 保养-->
        <div class="cont">
          <div class="li" v-for="(item, index) in carWashList[orderType]" :key="index">
            <div
              v-if="photoMap[item.isShow]"
              class="upload-img"
              v-upload="{
                onUpload: upload,
                vin: false,
                index: item.imgType,
                refresh: true
              }"
            >
              <img v-show="!photoList[item.imgType]" class="car" src="~@/imgs/car.png" alt="" />
              <img v-show="!photoList[item.imgType]" class="camera" src="~@/imgs/camera.png" alt="" />
              <img v-show="photoList[item.imgType]" class="upload-img" :src="photoList[item.imgType]" alt="" />
              <img
                v-show="photoList[item.imgType]"
                @click.stop="photoList[item.imgType] = ''"
                class="uploadClose"
                src="~@/imgs/close.png"
                alt=""
              />
            </div>
            <div v-if="photoMap[item.isShow]" class="tips">
              {{ item.text }}<span v-if="item.required" class="themeColor"> *</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- verificationStatus -->
    <div class="btn" @click="sureToOff()">
      <tt-button
        :text="codeInfo.verificationStatus == 1 ? '立即核销' : '不可核销（请客户出示可用的券码）'"
        :type="codeInfo.verificationStatus == 2 ? 'active' : ''"
      />
    </div>

    <!-- 示例 -->
    <van-popup v-model="showPupup" round closeable position="bottom" class="popup-about">
      <div class="content-block">
        <p class="tt">图片资料范例</p>
        <p class="tip marginTop marginBottom">请按照示例上传完整清晰图片</p>

        <div class="img2">
          <img src="~@/imgs/image/car.png" alt="" />
          <div class="marginTop marginBottom textAlignCenter">
            <span style="color:#0081F3">
              需显露车牌及车店一体的照片
            </span>
            示意图
          </div>
        </div>

        <div class="img2">
          <img src="~@/imgs/image/car_3.png" alt="" />
          <div class="marginTop marginBottom textAlignCenter">
            <span style="color:#0081F3">
              人车合影
            </span>
            示意图
          </div>
        </div>
        <div class="img2">
          <img src="~@/imgs/image/car.png" alt="" />
          <div class="marginTop marginBottom textAlignCenter">
            <span style="color:#0081F3">
              显露车牌及车店一体的作业中照片
            </span>
            示意图
          </div>
        </div>
        <div @click="showPupup = false">
          <tt-button text="知道了"></tt-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import ttButton from '@/components/ttButton'
import config from '@/configs/config'
// import VConsole from "vconsole/dist/vconsole.min.js"; // import vconsole
const statusType = {
  '0': '初始状态',
  '1': '已核销',
  '2': '已确认',
  '3': '已取消'
}
export default {
  components: {
    ttButton
  },
  data() {
    return {
      statusType,
      lock: false,
      codeInfo: {},
      showPupup: false,
      img1: require('../../imgs/car.png'),
      img2: require('../../imgs/camera.png'),
      orderType: 'MAINTAIN_ORDER',
      carWashList: {
        MAINTAIN_ORDER: [
          {
            imgType: 'vehicleWorkingPhoto',
            text: '需显露车牌及车店一体的照片',
            required: true,
            isShow: 'isVehicleWorkingPhoto'
          },
          {
            imgType: 'elseWorkPhoto',
            text: '人车合影',
            required: true,
            isShow: 'isElseWorkPhoto'
          },
          {
            imgType: 'workingPhoto',
            text: '显露车牌及车店一体的作业中照片',
            required: true,
            isShow: 'isWorkingPhoto'
          }
        ]
      },
      photoMap: {
        isVehicleWorkingPhoto: false, //车辆与门店合照
        isVehicleOilPhoto: false, //机油和车辆合照
        isBeforeWorkPhoto: false, //  作业前照片
        isAfterWorkPhoto: false, //  作业后照片
        isWorkingPhoto: false, // 作业中照片
        isWorkOrderPhoto: false, // 工单照片
        isElseWorkPhoto: false //其他照片 人车合影
      },
      photoList: {
        vehicleWorkingPhoto: '', // 显露车牌及车店一体的作业中照片
        vehicleOilPhoto: '', // 使用的机油与车辆合影照片
        beforeWorkPhoto: '', // 作业前照片
        afterWorkPhoto: '', // 作业后照片
        workingPhoto: '', // 作业中照片
        workOrderPhoto: '', // 工单照片
        elseWorkPhoto: '' // 其他照片
      }
    }
  },
  computed: {
    shopId() {
      const shopInfo = tuhu.store.state.userInfo
      return shopInfo ? shopInfo.shopId : ''
    },
    verifyCode() {
      return this.options ? this.options.verifyCode : tuhu.getParam('verifyCode')
    }
  },
  mounted() {
    // let vConsole = new VConsole();
    this.viewCode()
  },
  methods: {
    upload(val) {
      if (val && val.code === '200') {
        this.photoList[val.index] = val.data
      } else {
        tuhu.toast(val.message || '网络错误')
      }
    },
    async viewCode() {
      const data = await tuhu.fetch(`${config.apis.GET_VERUFUCATION_CODE}`, {
        method: 'post',
        body: JSON.stringify({
          id: this.verifyCode
        })
      })
      if (data.code === '200') {
        this.codeInfo = data.data
        if (data.data.photoMap) {
          this.photoMap = data.data.photoMap && JSON.parse(data.data.photoMap)
        }
      } else {
        tuhu.toast(data.message)
      }
    },
    // 立即核销
    async sureToOff() {
      if (!this.codeInfo || this.codeInfo.verificationStatus == 2) return false
      let res = this.ckeckImg()
      if (!res) return
      if (this.lock) return
      this.lock = true
      const { vehicleWorkingPhoto, elseWorkPhoto, workingPhoto } = this.photoList
      tuhu.showIndicator()
      const data = await tuhu.fetch(`${config.apis.TO_VALIDATE}`, {
        method: 'post',
        body: JSON.stringify({
          id: this.verifyCode,
          shopId: this.shopId,
          isVehicleWorkingPhoto: vehicleWorkingPhoto,
          isWorkingPhoto: workingPhoto,
          isElseWorkPhoto: elseWorkPhoto
        })
      })

      if (data.code === '200') {
        tuhu.hideIndicator()
        this.lock = false
        tuhu.toast('核销成功')
        let info = {
          secondClassName: data.data.serviceProviderName,
          verificationCode: data.data.providerVerificationCode,
          orderPrice: data.data.orderPrice,
          goodsOrderId: data.data.goodsOrderId,
          id: data.data.id,
          shopId: data.data.shopId,
          vehicleWorkingPhoto: data.data.isVehicleWorkingPhoto,
          workingPhoto: data.data.isWorkingPhoto,
          elseWorkPhoto: data.data.isElseWorkPhoto
        }
        tuhu.sessionStorage.setItem('shopOrderDetail', JSON.stringify(info))
        setTimeout(() => {
          tuhu.redirectTo({
            url: '/pages/orderDetail/index',
            data: {
              ListInfo: info
            },
            query: {
              success: data.code === '200' ? 1 : ''
            }
          })
        }, 300)
      } else {
        tuhu.hideIndicator()
        this.lock = false
        tuhu.toast(data.message)
      }
    },
    ckeckImg() {
      if (!this.photoList.vehicleWorkingPhoto && this.photoMap.isVehicleWorkingPhoto)
        return tuhu.toast('请上传显露车牌及车店一体的照片')
      if (!this.photoList.elseWorkPhoto && this.photoMap.isElseWorkPhoto) return tuhu.toast('请上传人车合影照片')
      if (!this.photoList.workingPhoto && this.photoMap.isWorkingPhoto)
        return tuhu.toast('请上传显露车牌及车店一体的作业中照片')
      return true
    }
  }
}
</script>

<style lang="less" scoped>
._content {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.content {
  flex: 1;
  overflow-y: auto;
  padding: 0.5rem;
  background: #f5f5f5;
  height: 100%;
  width: 100%;

  .item-box1 {
    display: flex;
    justify-content: space-between;
    border-radius: 0.4rem;
    background: #fff;
    box-shadow: 0rem 0rem 0.6rem 0rem rgba(0, 0, 0, 0.04);
    padding: 1.1rem 1.5rem 1.1rem 0.75rem;
    font-size: 0.7rem;
    margin-bottom: 0.4rem;
  }

  .item-box2 {
    border-radius: 0.4rem;
    background: #fff;
    box-shadow: 0rem 0rem 0.6rem 0rem rgba(0, 0, 0, 0.04);
    padding: 0.6rem 1.5rem 1.1rem 0.75rem;
    font-size: 0.7rem;
    margin-bottom: 0.4rem;

    .box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-content: center;

      .img {
        .icon {
          width: 0.8rem;
          height: 0.8rem;
        }
      }
    }
  }

  .cont {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0.75rem;

    .li {
      margin-bottom: 1rem;

      .upload-img {
        position: relative;
        width: 6.5rem;
        height: 4rem;
        background: url('~@/imgs/img-box.png') no-repeat;
        background-size: 100% 100%;

        .car {
          width: 100%;
          height: 100%;
          padding: 0.2rem 0.3rem;
        }

        .camera {
          position: absolute;
          height: 2rem;
          width: 2rem;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }

        .uploadClose {
          position: absolute;
          width: 1rem;
          height: 1rem;
          top: 0.1rem;
          right: 0.1rem;
        }
      }

      .tips {
        width: 6.5rem;
        text-align: center;
        margin-top: 0.2rem;
      }
    }
  }
}

.popup-about {
  padding: 0.75rem;
  z-index: 11000 !important;

  .content-block {
    .tt {
      font-size: 1rem;
      font-weight: 600;
    }

    .tip {
      color: rgb(255, 155, 15);
      font-size: 0.8rem;
    }
  }

  //common
  .marginTop {
    margin-top: 0.5rem;
  }

  .marginBottom {
    margin-bottom: 0.5rem;
  }

  .textAlignCenter {
    text-align: center;
  }
}

.themeColor {
  // color: @xkThemeCoder;
  color: red;
}

.btn {
  width: 90%;
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/verifyCode/tpCode.vue